import { toast } from "react-toastify";

import {
  fetchUpdateOfferStart,
  fetchUpdateOfferSuccess,
  fetchUpdateOfferFailure,
} from "./reducer";

import { UPDATE_PARTNER_OFFER } from "../../constants/constants";

import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";

import { setSuccessMessage } from "../../toastMessage/action";

export const updatePartnerOffer =
  (
    jsonObj,
    offerId,
    setLoading,
    onSuccess,
    successMessage = "Offer updated successfully"
  ) =>
  async (dispatch) => {
    dispatch(fetchUpdateOfferStart());

    setLoading?.(true);

    try {
      const response = await determineBaseUrlAndPerformApiCall(
        UPDATE_PARTNER_OFFER(offerId),
        "PUT",
        jsonObj
      );

      if (response?.error) {
        const errorMessage =
          response.error.message || "Failed to update offer";

        dispatch(fetchUpdateOfferFailure(errorMessage));

        toast.error(errorMessage);
      } else {
        dispatch(fetchUpdateOfferSuccess(response));

        dispatch(setSuccessMessage(true));

        toast.success(successMessage);

        if (onSuccess) {
          onSuccess(response);
        }
      }
    } catch (error) {
      const errorMessage =
        error?.message || "Something went wrong";

      dispatch(fetchUpdateOfferFailure(errorMessage));

      toast.error(errorMessage);
    } finally {
      setLoading?.(false);
    }
  };